import { render, staticRenderFns } from "./TicketSubmit.vue?vue&type=template&id=7fcc3492&scoped=true"
import script from "./TicketSubmit.vue?vue&type=script&lang=js"
export * from "./TicketSubmit.vue?vue&type=script&lang=js"
import style0 from "./TicketSubmit.vue?vue&type=style&index=0&id=7fcc3492&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc3492",
  null
  
)

export default component.exports